import initialState from "./initialState";

export const types = {
  reset: "reset",
  SET_DATA_SOURCE_LIST: "SET_DATA_SOURCE_LIST",
};

export default {
  /**
   * Resets the store module
   */
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },

  /**
   * Stores the list of datasources
   */
  [types.SET_DATA_SOURCE_LIST]: (state, dataSourceList) => {
    state.dataSources = dataSourceList;
    state.dataSourcesById = Object.keys(dataSourceList);
  },
};
